import { render, staticRenderFns } from "./two-factor-backup-code-dialog.vue?vue&type=template&id=be83c848&"
import script from "./two-factor-backup-code-dialog.vue?vue&type=script&lang=ts&"
export * from "./two-factor-backup-code-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports